import useSWR from 'swr';
import { useClientVD } from '../../hooks/useClientVD';
import { honoFetcher } from '../../lib/honoFetcher';

export function useDataset(id?: string) {
  const client = useClientVD();

  const { data } = useSWR(
    id ? ['datasets', id] : null,
    async () => {
      const result = await honoFetcher(
        client.datasets[':datasetId'].$get({ param: { datasetId: id! } }),
      );
      return result;
    },
    {
      suspense: true,
      revalidateOnFocus: false,
    },
  );

  return data;
}
